/*
	'Documentação'
	-------------------

	Este componente funciona como um wrapper para o CheckboxGroup. Sendo assim, ele deve
	receber, em geral, muitas das Props que seriam passadas para o CheckboxGroup.

	Algumas particularidades:

	# As seguintes Props do CheckboxGroup são mapeadas com nomes diferentes. Os nomes das Props do
	CheckboxGroup que devem ser utilizados ao chamar o DropdownFilter são:
	__________________________________________
	|  CheckboxGroup  |    DropdownFilter    |
	------------------------------------------
	| values          | checkboxValuesList   |
	| value           | filtro               |
	| key             | keyName              |
	------------------------------------------

	Além disso, apesar de o botão ocupar apenas uma porção
	do espaço que lhe foi reservado, o componente precisa de uma área
	maior para renderizar o menu dropdown que contém o CheckboxGroup.
	Certifique-se de que o componente tem espaço suficiente para que a lista não apareça quebrada.

	Se quiser adicionar novas props ou modificar o componente, por favor atualize a 'documentação'!
*/
import React from 'react';
import { ButtonDropdownStyle } from '../Table/table.style';
import CheckboxGroup from '../Checkbox/checkboxGroup.component';

class DropdownFilter extends React.Component {
	constructor(props) {
		super(props);
		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.container = React.createRef();
		this.buttonContainer = React.createRef();
		this.state = {
			show: false,
			wasButtonClicked: false,
		};
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
		this.buttonContainer.addEventListener('mouseenter', this.handleClickInsideButton);
		this.buttonContainer.addEventListener('mouseleave', this.handleClickOutsideButton);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		const { wasButtonClicked } = this.state;
		if (this.container.current && !this.container.current.contains(event.target)) {
			if (!wasButtonClicked) {
				this.setState({
					show: false,
				});
			}
		}
	}

	handleButtonClick = () => {
		this.setState(prevState => ({
			show: !prevState.show,
			wasButtonClicked: true,
		}));
	}

	handleClickOutsideButton = () => {
		this.setState(() => ({
			wasButtonClicked: false,
		}));
	}

	handleClickInsideButton = () => {
		this.setState(() => ({
			wasButtonClicked: true,
		}));
	}

	render() {
		const {
			state: {
				show,
			},
			props: {
				filtro,
				checkboxValuesList,
				handleChangeCheckboxGroup,
				setFieldValue,
				id,
				name,
				keyName,
				aroundAlign,
				notObjectValue,
				error,
			},
		} = this;

		return (
			<React.Fragment>
				<div
					className='dropdown'
				>
					<div className='d-flex justify-content-end'>
						<ButtonDropdownStyle
							onClick={this.handleButtonClick}
							className='btn btn-secondary dropdown-toggle'
							ref={buttonContainer => this.buttonContainer = buttonContainer}
							// data-toggle='dropdown'
							type='button'
							id='dropdownMenuButton'
							aria-haspopup='true'
							aria-expanded={show}
						>
							Filtro
						</ButtonDropdownStyle>
					</div>
					<div
						className={show ? 'dropdown-menu show' : 'dropdown-menu'}
						aria-labelledby='dropdownMenuButton'
						ref={this.container}
					>
						<div
							className='col-12 ml-2 mr-2'
						>
							<CheckboxGroup
								styleInput
								id={id}
								name={name}
								key={keyName}
								value={filtro}
								values={checkboxValuesList}
								handleChangeCheckboxGroup={handleChangeCheckboxGroup}
								setFieldValue={setFieldValue}
								aroundAlign={aroundAlign}
								notObjectValue={notObjectValue}
								error={error}
							/>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default DropdownFilter;
